/*
	Form Controls
*/
import './handler'
import './control'
import './controls/text-field'
import './controls/select-field'
import './controls/check-box'
import './controls/radio-btn'
import './controls/radio-group'
import './controls/touch-ripple'
import './controls/range-slider'

// must manually import this as it adds quite a bit of overhead with tiptap.js
// import './controls/text-editor'